import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { isSmallScreenWidth } from 'dashboard/components/widgets/conversation/mobile/mobileConversationChrome';

// SiteUp: "e celular" = o mesmo 768 do Tailwind md e de wootConstants.SMALL_SCREEN_BREAKPOINT.
export function useSmallScreen() {
  const { width } = useWindowSize();
  const isSmallScreen = computed(() => isSmallScreenWidth(width.value));
  return { isSmallScreen, windowWidth: width };
}
